import { useCallback, useState } from 'react';

/** Quantas linhas uma lista mostra de início e quantas cada "Mostrar mais" acrescenta. */
export const REVEAL_STEP = 15;

export interface RevealedRows<Row> {
  visible: Row[];
  /** Quantas linhas ainda estão escondidas; zero esconde o botão. */
  hiddenCount: number;
  showMore(): void;
}

/**
 * Mostra uma lista aos poucos sem buscar de novo: as linhas já estão todas em mãos (cache
 * persistido), e o que cresce é só a janela. A janela nunca encolhe sozinha — uma
 * revalidação que devolve a mesma lista não joga a pessoa de volta ao começo.
 */
export function useRevealedRows<Row>(rows: Row[], step: number = REVEAL_STEP): RevealedRows<Row> {
  const [limit, setLimit] = useState(step);
  const showMore = useCallback(() => setLimit((current) => current + step), [step]);
  return {
    visible: rows.slice(0, limit),
    hiddenCount: Math.max(rows.length - limit, 0),
    showMore,
  };
}
